import type { Fetch } from './types/fetch.js';

/**
 * Constructs a fetch with default options
 *
 * ```ts
 * import { withDefaults } from '@lessonnine/api-client.js';
 *
 * const fetch = withDefaults(globalThis.fetch, {
 *  headers: {
 *   'x-custom-header': 'value',
 *  },
 * });
 * ```
 * @ignore
 */
export const withDefaults =
  <P, D extends Partial<P>>(fetch: Fetch<P>, defaults: D): Fetch<Omit<P, keyof D> & Partial<D>> =>
  async (info, options) =>
    fetch(info, { ...defaults, ...options } as unknown as RequestInit & P);

// Added to avoid breaking changes, can be removed in next major version
/* eslint-disable prefer-destructuring -- needed */
export const Request: typeof globalThis.Request = globalThis.Request;
export const Headers: typeof globalThis.Headers = globalThis.Headers;
export const Response: typeof globalThis.Response = globalThis.Response;
/* eslint-enable prefer-destructuring -- needed */

export { Fetch } from './types/fetch.js';

export { FetchEnhancer } from './types/fetchEnhancer.js';

// Re-export enhancers
export * from './enhancers/retry/index.js';
export * from './enhancers/agent.js';
export * from './enhancers/trackingUuid.js';
export * from './enhancers/timeout.js';
export * from './util.js';
